// #@flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A map displaying live bushfire data, including advice, emergency warnings and burn-area outlines, with the ability to focus on 6 of Australia's states and territories.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Live bushfire warnings",
  id: "live-bushfire-map",
  linkPrefix: "/interactives",
  tags: ["Weather", "Configurable", "Map", "Data viz"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    // "https://www.smh.com.au/interactive/2020/bushfire/data-center/stage/index.html?resizable=true&embed=true&map=firealert",
    "https://www.smh.com.au/interactive/2020/bushfire/data-center/index.html?resizable=true&embed=true&map=firealert",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "LiveBushfireMapConfigTool" */ "app/components/tools/LiveBushfireMapConfigTool/LiveBushfireMapConfigTool"),
    loading: DynamicImportLoader,
    modules: ["LiveBushfireMapConfigTool"]
  })
};

export default CONFIG;

